/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class JudgeService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Judge chat completions
     * @param requestBody The chat completion to evaluate.
     * @param projectId
     * @returns any Successful request
     * @throws ApiError
     */
    public judgePost(
        requestBody: {
            /**
             * The prompt message of the chat completion to judge
             */
            prompt: string;
            /**
             * The context passed to the LLM, for example previous messages in the chat completion.
             */
            context?: string | null;
            /**
             * A list of tools passed to the LLM in the completion.
             */
            tools?: Array<{
                type: 'function';
                function: {
                    name: string;
                    description?: string;
                    parameters: Record<string, any>;
                };
            }>;
            /**
             * The response to judge
             */
            response: string;
            /**
             * Slug of the judge to use
             */
            judge: string;
            /**
             * The unique ID of the user who triggered the chat completion.
             */
            distinctId?: string;
            /**
             * The ID of the group or organization the chat completion is associated with.
             */
            groupId?: string;
            /**
             * A dictionary of properties associated with the chat completion, with key-value pairs representing chat-specific data.
             */
            properties?: Record<string, any>;
            /**
             * The ID of the trace the chat completion is associated with. Typically the chat ID.
             */
            traceId?: string;
            /**
             * Span ID for tracing the specific request within the trace context.
             */
            spanId?: string;
            /**
             * Parent span ID in a distributed trace, useful for nested request tracking.
             */
            parentSpanId?: string;
            /**
             * Start time of the span in milliseconds.
             */
            startTimeMs?: number;
            /**
             * End time of the span in milliseconds.
             */
            endTimeMs?: number;
            /**
             * Name of the service where the event originated.
             */
            service?: string;
            /**
             * Duration of the judgement in milliseconds.
             */
            durationMs?: number;
            /**
             * Name of the span, representing a specific operation in distributed tracing tracing.
             */
            spanName?: string;
            /**
             * The ID of the model used for the chat completion.
             */
            model: string;
            /**
             * Unix timestamp of the chat completion in milliseconds, representing the exact time the completion was completed.
             */
            timestamp?: number;
        },
        projectId?: string | null,
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: {
            /**
             * The prompt message of the chat completion to judge
             */
            prompt: string;
            /**
             * The context passed to the LLM, for example previous messages in the chat completion.
             */
            context?: string | null;
            /**
             * A list of tools passed to the LLM in the completion.
             */
            tools?: Array<{
                type: 'function';
                function: {
                    name: string;
                    description?: string;
                    parameters: Record<string, any>;
                };
            }>;
            /**
             * The response to judge
             */
            response: string;
            /**
             * Slug of the judge to use
             */
            judge: string;
            /**
             * A critique of the provided response
             */
            critique: string;
            outcome: 'pass' | 'fail';
            /**
             * The unique ID of the user who triggered the chat completion.
             */
            distinctId?: string;
            /**
             * The ID of the group or organization the chat completion is associated with.
             */
            groupId?: string;
            /**
             * The ID of the trace the chat completion is associated with. Typically the chat ID.
             */
            traceId?: string;
            /**
             * The ID of the model used for the chat completion.
             */
            model: string;
            /**
             * Unix timestamp of the chat completion in milliseconds, representing the exact time the completion was completed.
             */
            timestamp?: number;
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/judge',
            query: {
                'projectId': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
}
